import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import * as yup from "yup";

export interface IConsultationDatatableRowFormMeta {
  destination: FormInputMeta,    
  message: FormInputMeta,
  date: FormInputMeta,
  //
  schema: any,
}

const ConsultationDatatableRowFormMeta = {} as IConsultationDatatableRowFormMeta;

ConsultationDatatableRowFormMeta.destination = {
  name: 'destination',
  type: 'text',
  label: 'Destination',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
ConsultationDatatableRowFormMeta.message = {
  name: 'message',
  type: 'text',
  label: 'Message',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
ConsultationDatatableRowFormMeta.date = {
  name: 'date',
  type: 'date',
  label: 'Date',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};

ConsultationDatatableRowFormMeta.schema = yup.object().shape(getValidationSchema(ConsultationDatatableRowFormMeta));

export default ConsultationDatatableRowFormMeta;
